<template>
  <div class="selectTree">
    <el-select filterable :filter-method="filterMethod" class="main-select-tree" ref="selectTree" multiple v-model="transitValue" @remove-tag="removeTag"
      clearable @clear="clearInput" @focus="blurInput" style="width: 100%;">
      <el-option v-for="item in selectOptions" :key="item.id" :label="item.enterprieName" :value="item.id" style="display: none;" />
      <el-tree class="main-select-el-tree" ref="selecteltree" :filter-node-method="filterNode" show-checkbox @check-change="handleCheckChange"
        :highlight-current="true" :data="dataArray" :props="defaultProps" :expand-on-click-node="false" node-key="id" :current-node-key="currentKey"
        :check-strictly="true">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span :title="data.enterprieName">{{ node.label }}</span>
        </span>
      </el-tree>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'selectTree',
  data() {
    return {
      transitValue: [],
      selectOptions: [],
      currentKey: null,
      defaultProps: {
        label: 'enterprieName',
        children: 'userList'
      }
    }
  },
  props:['dataArray'],
  computed: {
    formatData() {
      let result = []
      function getChild(item) {
        if (item && item.length) {
          item.forEach((i, x) => {
            if (Array.isArray(i['userList'])) {
              result.push(i)
              getChild(i['userList'])
            } else {
              result.push(i)
            }
          })
        }
      }
      getChild(this.dataArray)
      return result
    }
  },
  methods: {
    filterMethod(value) {
      this.$refs['selecteltree'].filter(value.trim())
    },
    blurInput() {
      this.$refs['selecteltree'].filter('')
    },
    filterNode(value, data) {
      if (!value) return true
      return data.enterprieName.indexOf(value) !== -1
    },
    clearInput() {
      this.$refs['selecteltree'].setCheckedKeys([])
    },
    removeTag(e) {
      this.$refs['selecteltree'].setChecked(e, false)
    },
    handleCheckChange() {
      let check = this.$refs['selecteltree'].getCheckedNodes()
      console.log(check)
      let arr = check.filter((i) => !i.children)
      this.transitValue = arr.map((i) => {
        return i.id
      })
      this.$emit('treeChange', arr)
    }
  },
  watch: {
    formatData: {
      immediate: true,
      handler: function (n) {
        if (n.length > 0) {
          this.selectOptions = n
        } else {
          this.selectOptions = []
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.custom-tree-node {
  font-size: 14px;
}
.main-select-el-tree {
  max-height: 300px;
  overflow-y: auto;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item {
  display: none;
}
</style>
